import { Controller } from "@hotwired/stimulus"
import { logger } from "../logger"

// Connects to data-controller="report-form-v3"
//
// Handles form submission for V3 report designer
// Ensures positions are recalculated before submitting
//
export default class extends Controller {
  connect() {
    logger.log("[Report Form V3] Connected")
    
    // Bind the handler once and store it
    this.boundHandleTurboSubmit = this.handleTurboSubmit.bind(this)
    
    // Listen to Turbo form submission event
    this.element.addEventListener('turbo:submit-start', this.boundHandleTurboSubmit)
  }
  
  disconnect() {
    this.element.removeEventListener('turbo:submit-start', this.boundHandleTurboSubmit)
  }

  handleTurboSubmit(event) {
    logger.log("[Report Form V3] Turbo form submitting, recalculating positions...")
    this.recalculatePositions()
  }

  handleSubmit(event) {
    logger.log("[Report Form V3] Form submitting, recalculating positions...")
    this.recalculatePositions()
  }
  
  recalculatePositions() {
    
    // Find the report-columns-sortable controller for the selected columns list
    const selectedColumnsList = this.element.querySelector('#selectedColumnsList')
    
    if (selectedColumnsList) {
      const sortableController = this.application.getControllerForElementAndIdentifier(
        selectedColumnsList,
        'report-columns-sortable'
      )
      
      if (sortableController && typeof sortableController.recalculatePositions === 'function') {
        sortableController.recalculatePositions()
        logger.log("[Report Form V3] Positions recalculated successfully")
      } else {
        logger.log("[Report Form V3] Warning: Could not find sortable controller or recalculatePositions method")
      }
    } else {
      logger.log("[Report Form V3] Warning: Could not find selectedColumnsList element")
    }

    // Clear the properties cache on form submit
    const propertiesPanel = this.element.querySelector('[data-controller*="properties-sidepanel"]')
    if (propertiesPanel) {
      const propertiesPanelController = this.application.getControllerForElementAndIdentifier(
        propertiesPanel,
        'properties-sidepanel'
      )
      
      if (propertiesPanelController && typeof propertiesPanelController.clearCache === 'function') {
        propertiesPanelController.clearCache()
        logger.log("[Report Form V3] Properties cache cleared")
      }
    }
    
    // Let the form submit naturally
    return true
  }
}

